import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import AddCustomerEntryForm from "./AddCustomerEntryForm";

function CustomerDataFeedbackForm() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>New Customer Data & Feedback Form</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <AddCustomerEntryForm />
      </div>
    </div>
  );
}

export default CustomerDataFeedbackForm;
